<template>
    <el-popover
        v-model="interimStopNote"
        trigger="click"
        width="350"
        :visible-arrow="false"
        popper-class="interim-stop-note"
    >
        <div class="interim-stop-note__header">
            <div class="copy-bold black">Hinweis</div>
            <div class="smr-panel__actions__item smr-panel__actions__close" @click="closeClickHandler">
                <icon><IconClose/></icon>
            </div>
        </div>
        <div class="interim-stop-note__body copy-light black">
            Bei Routen mit öffentlichen Verkehrsmitteln, Bike & Ride und Park & Ride werden keine Zwischenziele berücksichtigt
        </div>
    </el-popover>
</template>
<script>
import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'
export default {
    components: {
        Icon,
        IconClose,
    },
    props: {
        interimStopNote: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        closeClickHandler() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss">
    .interim-stop-note {
        $block: &;
        position: absolute;
        top: 151px !important;
        left: 64px !important;
        padding: 16px;
        box-shadow: $popup-shadow;
        border-radius: 9px;
        border: 0;
        z-index: $overlay-highest-z !important;

        @include mq ($until: tablet) {
            width: 100% !important;
            margin: 0 !important;
            left: 50% !important;
            top: 95px !important;
            transform: translateX(-50%);
        }

        &:before {
            content: "";
            position: absolute;
            top: -10px;
            left: 60px;
            width: 20px;
            height: 10px;
            z-index: 200000;
            box-shadow: $popup-shadow;
            background-color: #ffffff;
            clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &__body {
            margin-top: 7px;
            padding-right: 32px;
            word-break: break-word;

            @include mq($until: tablet-landscape) {
                text-align: left;
                padding-right: 20px;
            }
        }
    }

</style>
